import React from "react";
import DashboardFooter from "../Dashboard/DashboardFooter/DashboardFooter";
import IDashboardBody from "./IDashboardBody/IDashboardBody";
import IDashboardHeader from "./IDashboardHeader/IDashboardHeader";
import "./institute-dashboard.style.scss";
export default function InstituteDashboard() {
  return (
    <div className="institute-dashboard-main">
      <IDashboardHeader />
      <IDashboardBody />
      <DashboardFooter />
    </div>
  );
}
